module.exports = __webpack_public_path__ + "static/media/gryphon-house-countertops.9f2f07b9.jpg";